import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../utils/contentful/contentfulQuery';

// ================================================================================================
// Emphasized Text Fragment
// ================================================================================================

export const emphasizedTextFragment = gql`
  fragment EmphasizedTextAll on EmphasizedText {
    ...ContentfulSysId
    text
  }
  ${contentfulSysIdFragment}
`;
